import { Avatar, Button, TableCell, TableRow, useTheme } from '@mui/material'

import { getTableTimestamp } from 'src/common/utils'
import { HelperWrapper } from 'src/components/helper-wrapper'
import { useMe } from 'src/hooks'
import { ETranslationNs, ITransactionLogDto } from 'src/types'
import { ExplorerLink } from './explorer-link.component'

import { useStyles } from './styles'
import { EyeOpenedIcon } from 'src/assets/icons/v2/EyeOpenedIcons'
import { EmptyUserIcon } from 'src/assets/icons/v2/EmptyUserIcon'

interface IProps {
  row: ITransactionLogDto
  handleOpen: () => void
}

export const TBodyRow = ({ row, handleOpen }: IProps) => {
  const theme = useTheme()
  const classes = useStyles()
  const { data: user } = useMe()

  return (
    <TableRow
      style={{
        borderTop: `1px solid ${theme.palette.custom.grey}`,
        borderBottom: `1px solid ${theme.palette.custom.grey}`,
      }}
      sx={{ 'td, th': { border: 0 } }}
    >
      <TableCell width="25%">
        <div className={classes.iconWrapper}>
          {row.user && (
            <Avatar
              src={row.user.image_small || row.user.image}
              alt={row.user.email}
              variant="circular"
            />
          )}
          {row.user?.name ?? row.user?.email}
        </div>
        {!row.user && <EmptyUserIcon size={36} />}
      </TableCell>
      <TableCell width="25%">
        <div className={classes.iconWrapper}>
          {row.account && (
            <Avatar
              src={row.account.image_small || row.account.image}
              alt={row.account.account_holder}
              variant="circular"
            />
          )}
          {row.account?.account_holder}
        </div>
        {!row.account && <EmptyUserIcon size={36} />}
      </TableCell>
      <TableCell width="15%">
        <ExplorerLink externalUrl={row.explorer_url} type={row.type} />
      </TableCell>
      <TableCell align="center" width="25%">
        {getTableTimestamp({ date: row.created_at, timezone: user?.timezone })}
      </TableCell>
      <TableCell align="center" width="10%">
        <div onClick={handleOpen} className={classes.button}>
          <EyeOpenedIcon size={24} />
        </div>
      </TableCell>
    </TableRow>
  )
}
